module.exports = __webpack_public_path__ + "static/media/01.70691e82.jpg";